// A name a page prints that may be a company's (BUGS.md X30; U356: "Any company name, anywhere, opens the record"). Pages
// whose names come in lists of mixed things (Industry's targets: a company, a right, a territory, a product line) print
// each through these, so a company's is a link to its record and the rest stay text.
import { CompanyName, type Go } from '../parts/index.js';

export interface Named { kind: string; id: string | null; name: string }

/** One name: a company's (kind 'organisation', with an id) is a link to its record; anything else is its words. */
export function TargetName({ t, go }: { t: Named; go?: Go | undefined }) {
  return t.kind === 'organisation' && t.id ? <CompanyName id={t.id} name={t.name} go={go} /> : <>{t.name}</>;
}

/** Names, comma-separated, each company's a link. */
export function TargetNames({ targets, go }: { targets: readonly Named[]; go?: Go | undefined }) {
  return <>{targets.map((t, i) => <span key={`${t.kind}-${t.id ?? t.name}-${i}`}>{i > 0 ? ', ' : ''}<TargetName t={t} go={go} /></span>)}</>;
}
